import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/Services/api.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

declare const Swal;
@Component({
  selector: 'app-holiday',
  templateUrl: './holiday.component.html',
  styleUrls: ['./holiday.component.css']
})
export class HolidayComponent implements OnInit {

  public holidaysData: any = {};
  public formObject: any = {
    date: {
      title: '',
      type: '',
      date: [],
    },
    week: {
      title: '',
      type: '',
      days: [],
    }
  }
  public formErrorObject: any = JSON.parse(JSON.stringify(this.formObject));
  public holidayLists = [];

  public dayFormRefresh:boolean = true;
  public weekFormRefresh:boolean = true;

  //Holiday Config
  public closeHolidayFormPopup: boolean = true;
  public updateRouteOnly:boolean = true;
  public selectedHoliday:any = {};

  constructor(
    private api: ApiService,
    private swal: SweetAlert,
    
  ) { }

  ngOnInit(): void {
    this.getHolidayList();
  }

  getHolidayList() {
    this.api.getHolidays({}).then((res: any) => {
      if (res.status == 'success') {
        this.holidaysData = res.data;
      } else {

      }
    })
  }

  onChange(day, checked) {
    if (checked) {
      this.formObject['week'].days.push(day);
    } else {
      const index = this.formObject['week'].days.indexOf(day);
      if (index > -1) {
        this.formObject['week'].days.splice(index, 1);
      }
      // this.formObject['week'].days.push(day);
    }
    // console.log
  }
  formValidation(type) {
    let isValid = true;
    let fields = Object.keys(this.formObject[type]);
    for (let i = 0; i < fields.length; i++) {
      let key = fields[i]; // this.errorObject[key] = key.split(/(?=[A-Z])/).join(" ").toLowerCase() + ' is required.';
      this.formErrorObject[type][key] = '';
      if (this.formObject[type][key] == '' || this.formObject[type][key] == null || this.formObject[type][key] == undefined || this.formObject[type][key].length <= 0) {
        this.formErrorObject[type][key] = key.charAt(0).toUpperCase() + key.slice(1) + ' is required.';
        isValid= false;
      }
    }
    return isValid;


  }
  getSelectedDates(e: any) {
    this.formObject.date.date = e.dateStr.split(',').map((date) => {
      return new Date(date.trim()).getTime();
    })
  }

  save(type: string) {
    this.formObject[type].type = type;
    let validate = this.formValidation(type);
    if (validate) {
      let obj = [];
      if (type == 'date') {
        obj = this.formObject[type]['date'].map((day) => {
          return {
            title: this.formObject[type].title,
            date: day,
            type: type
          };
        });
      } else if (type == 'week') {
        obj = this.formObject[type]['days'].map((day) => {
          return {
            title: this.formObject[type].title,
            day: day,
            type: type
          };
        });
      }

      this.api.addHolidays({formData: obj}).then((res: any) => {
        if (res.status == 'success') {
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          this.getHolidayList();
          this.formReset(type);
          // setTimeout(()=>{
          //   this.manageRouteHoliday(this.formObject[type].title,type)
          // },2000);
        } else {
          this.swal.swalFunction('error', res.status, res.message, 4000);
        }
      });
    }
    // console.log('Error Message ', this.formErrorObject[type])
  }

  formReset(type){
    if(type=='date'){
      this.dayFormRefresh = false;
      this.formObject.date.title = '';
      this.formObject.date.date = [];
    }else if(type=='week'){
      this.weekFormRefresh = false;
      this.formObject.week.title = '';
      this.formObject.week.days = [];
    }
    setTimeout(()=>{ this.weekFormRefresh = true;this.dayFormRefresh=true;},300);
  }

  del(data:any){
     Swal.fire({
      title: 'Are you sure?',
      html: `<p>You want to delete all holidays list under <br><b>${data.key}</b> title.</p>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor:  '#d33',//'#3085d6',
      //  cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.delHoliday(data);
        /* Swal.fire(
          'Deleted!',
          'Your file has been deleted.',
          'success'
        ); */
      }
    });
  }
  delHoliday(data:any){
    let obj = {
      title:data.key,
      //holidayID:[], 
    }
    //data.value.filter((e)=>obj.holidayID.push(e.holidayID));  all holidayId under title
    this.api.deleteHolidays(obj).then((res:any)=>{
           if(res.status=='success'){             
            this.swal.swalFunction(res.status, res.status, res.message, 2000);
            this.getHolidayList();
           }else{
            this.swal.swalFunction('error', res.status, res.message, 4000);
        
           }
    })
  }
  manageRouteHoliday(holiday,type){
    Swal.fire({
      title: 'Holiday Configuration!',
      text: 'Do you want to configure this holiday for route.',
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Configure'
    }).then((result) => {
      if (result.isConfirmed) {
        this.selectedHoliday = {
          ...holiday,
          type
        };
       this.closeHolidayFormPopup = false;
      }
    });
  }

  submitRouteHoliday(obj) {
    /* api calls */
    this.api.transportManagerRouteHolidayUpdate(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 3000);
      }
    }).catch((err) => {
      console.log(err);
    });

  }

  
}
